/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2022-03-16 11:08:05
 * @modify date 2022-03-16 11:08:05
 * @desc https://micro-zoe.github.io/micro-app/docs.html#/
 */
import { EnumMicroNoticeType } from '@mamba/clients';
import microApp from '@micro-zoe/micro-app';
import lodash from 'lodash';
import React from 'react';
import { history, setCreateHistoryOptions } from 'umi';
enum EnumMicroApp {
  /** 应用名称 key */
  APP = 'app',
  /** Protal 路径标记 */
  Protal = '@Protal',
}
microApp.start({
  inline: true,
  // disableSandbox: true
  fetch(url, options, appName) {
    if (
      lodash.some(['easytoanalyze.min.js'], (item) =>
        lodash.includes(url, item),
      )
    ) {
      return Promise.resolve('');
    }
    return fetch(url, options).then((res) => {
      return res.text();
    });
  },
});
function getRouterPath(loca) {
  // 当前 微应用 页面地址
  const microPage = lodash.head(lodash.split(React.$Pages.Micro_micro, ':'));
  // 微应用 App 名称
  const app = lodash.get(loca, EnumMicroApp.APP);
  // 根路径地址
  if (lodash.includes(loca.href, EnumMicroApp.Protal)) {
    loca.path = lodash.last(lodash.split(loca.href, EnumMicroApp.Protal));
  } else if (app) {
    // 微应用 存在 APP 名称地址前缀 则跳过
    const base = lodash.includes(loca.href, app) ? '' : app;
    loca.path = lodash.join(
      [microPage, base, lodash.trimStart(loca.href, '/')],
      '',
    );
  }
  return loca.path || loca;
}
microApp.setGlobalData({
  // 全局 基座路由控制
  $router: {
    push(loca) {
      console.log('LENG ~ push ~ loca', loca);
      history.push(getRouterPath(loca));
    },
    replace(loca) {
      console.log('LENG ~ replace ~ loca', loca);
      history.replace(getRouterPath(loca));
    },
    back() {
      history.block();
    },
  },
});
interface INextDataOptions {
  appName: string;
  type?: EnumMicroNoticeType;
  data?: any;
}
/**
 * 信息变更
 * @export
 * @param {*} { location }
 */
export function nextData(options: INextDataOptions) {
  try {
    if (options.appName) {
      microApp.setData(options.appName, options as any);
    }
  } catch (error) {
    console.error('LENG ~ nextData', error);
  }
}
/**
 * 重写配置信息
 * @return {*}
 * @memberof MicroMiddleware
 */
export function rewriteConfig() {
  if (window.__MICRO_APP_BASE_ROUTE__) {
    setCreateHistoryOptions({
      basename: window.__MICRO_APP_BASE_ROUTE__,
    });
  }
}
/**
 * 路由改变
 * @export
 * @param {*} { location }
 */
export function microAppRouteChange({ location }) {
  if (lodash.eq(location.pathname, '/')) {
    return;
  }
  nextData({
    appName: lodash.snakeCase(location.pathname),
    type: EnumMicroNoticeType.RouteChange,
    data: location,
  });
}
Object.defineProperty(React.Component.prototype, '$NextData', {
  get: lodash.constant(nextData),
});
declare module 'react' {
  interface Component {
    readonly $NextData: typeof nextData;
  }
}
declare global {
  interface Window {
    __MICRO_APP_NAME__: boolean;
    __MICRO_APP_ENVIRONMENT__: boolean;
    __MICRO_APP_PUBLIC_PATH__: string;
    __MICRO_APP_BASE_URL__: string;
    __MICRO_APP_BASE_ROUTE__: string;
  }
}
